+-
            <!-- Indicators -->
            <!-- <ol class="carousel-indicators">
              <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
              <li data-target="#myCarousel" data-slide-to="1"></li>
              <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol> -->
        
            <!-- Wrapper for slides -->
            <!-- <div class="carousel-inner">
              <div class="item active">
                <img src="assets\img\fabric_1.jpg" alt="Los Angeles" style="width:100%;">
              </div>
        
              <div class="item">
                <img src="assets\img\home18.jpg" alt="Chicago" style="width:100%;">
              </div>
            
              <div class="item">
                <img src="assets\img\fabric_2.jpg" alt="New york" style="width:100%;">
              </div>
              
            </div>
         -->
            <!-- Left and right controls -->
            <!-- <a class="left carousel-control" href="#myCarousel" data-slide="prev">
              <span class="glyphicon glyphicon-chevron-left"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="right carousel-control" href="#myCarousel" data-slide="next">
              <span class="glyphicon glyphicon-chevron-right"></span>
              <span class="sr-only">Next</span>
            </a>
          </div> -->
        <!-- <div class="row">
            <div class="col-md-12 col-sm-12">
                <img src="assets\img\home18.jpg" style="width: 100%;">
                <div class="top-left">
                    <p>Presenting the latest bedding from the</p>
                    <p>home fabrics spring collection 2019</p>
                </div>
                <div class="top-right">
                    <p>Bedding As Soft</p>
                    <p>As Touch of Love</p>
                    <p>by</p><img src="assets\img\logo.jpg">
                </div>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-md-12">
                <mat-card class="home-content">
                    <p class="main-line"> A one-stop hub for a scintillating range of home furnishing items that are
                        flawlessly
                        designed to perfection.</p><br>
                    <p>HOME FABRICS started our endless journey in the year 2004. With contemporary leading products,
                        prompt
                        deliveries and
                        voluminous knowledge of the market, we have established ourselves as one of the most authentic
                        manufacturers
                        and
                        exporters of Home Furnishings.</p> <br>

                    <p>We involved in manufacturing fabrics in 100% polyester, Silk, cotton, Linen and its blends for
                        home
                        furnishing and
                        contract market, also in products-readymade drapery panels, duvet covers, pillow covers etc.,
                    </p>
                </mat-card>
            </div>
        </div>
        <div class="row ">
            <div class="col-md-12 col-sm-12 col-xs-12 ">
                <div class=" col-md-6 col-sm-12 col-xs-12 img-responsive column">
                    <img src="assets\img\home-22.jpg" class="image"></div>
                <div class=" col-md-6 col-sm-12 col-xs-12 img-responsive column">
                    <img src="assets\img\home-21.jpg" class="image">
                </div>
            </div>
        </div>
        <div class="row ">
            <div class="col-md-12 col-sm-12 col-xs-12 ">
                <img src="assets\img\home-23.jpg" class="image">
            </div>
        </div>
    </div>
</section> -->




<div class="preloader" *ngIf="!loading">
    <div class="loader rubix-cube">
        <div class="layer layer-1"></div>
        <div class="layer layer-2"></div>
        <div class="layer layer-3 color-1"></div>
        <div class="layer layer-4"></div>
        <div class="layer layer-5"></div>
        <div class="layer layer-6"></div>
        <div class="layer layer-7"></div>
        <div class="layer layer-8"></div>
    </div>
</div>

<!-- Banner section -->
<header *ngIf="page_type === 'home'">
    <div id="carouselExampleIndicators" class="carousel slide banner">
        <ol class="carousel-indicators">
            <li *ngFor="let img of result; let i = index" [class.active]="i === currentIndex" (click)="goToSlide(i)">
            </li>
        </ol>
        <div class="carousel-inner">
            <div *ngFor="let img of result; let i = index" class="carousel-item" [class.active]="i === currentIndex">
                <img class="d-block w-100" [src]="img" alt="Slide">
            </div>
        </div>
        <a class="carousel-control-prev" href="javascript:void(0)" role="button" (click)="prevSlide()">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="javascript:void(0)" role="button" (click)="nextSlide()">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</header>

<!-- Main Content -->
<main [style.margin-top]="'60px'">

    <div class="home-content" *ngIf="page_type === 'home'">
        <!-- 1. New Arrivals -->
        <section class="product-section bg-white">
            <div class="container">
                <div class="title-container">
                    <h1 class="hh" (click)="productCategory('new-arrivals')">New Arrivals</h1>
                </div>
                <div class="products-grid-wrapper">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 mb-4" *ngFor="let item of newArrival | slice:0:3">
                            <a [href]="detailLinkBase + item.productId" class="box">
                                <div class="image-box">
                                    <img [src]="item.image" loading="lazy">
                                </div>
                                <div class="product-info">
                                    <p class="product-name">{{item.productName}}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="view-more-container">
                        <a href="javascript:void(0)" class="view-more-link" (click)="productCategory('new-arrivals')">
                            View More 
                            <!-- <span class="arrow">&rarr;</span> -->
                            <!-- <span class="arrow">→</span> -->
                             <span class="arrow">
                                <fa-icon [icon]="faArrowRight"></fa-icon>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!-- 2. Now Trending -->
        <section class="product-section bg-grey">
            <div class="container">
                <div class="title-container">
                    <h1 class="hh" (click)="productCategory('now-trending')">Now Trending</h1>
                </div>
                <div class="products-grid-wrapper">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 mb-4" *ngFor="let item of nowTrending | slice:0:3">
                            <a [href]="detailLinkBase + item.productId" class="box">
                                <div class="image-box">
                                    <img [src]="item.image" loading="lazy">
                                </div>
                                <div class="product-info">
                                    <p class="product-name">{{item.productName}}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="view-more-container">
                        <a href="javascript:void(0)" class="view-more-link" (click)="productCategory('now-trending')">
                            View More 
                            <!-- <span class="arrow">&rarr;</span> -->
                              <span class="arrow">
                                <fa-icon [icon]="faArrowRight"></fa-icon>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!-- 3. All Time Best Selling -->
        <section class="product-section bg-white">
            <div class="container">
                <div class="title-container">
                    <h1 class="hh" (click)="productCategory('best-selling')">All Time Best Selling</h1>
                </div>
                <div class="products-grid-wrapper">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 mb-4" *ngFor="let item of bestSelling | slice:0:3">
                            <a [href]="detailLinkBase + item.productId" class="box">
                                <div class="image-box">
                                    <img [src]="item.image" loading="lazy">
                                </div>
                                <div class="product-info">
                                    <p class="product-name">{{item.productName}}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="view-more-container">
                        <a href="javascript:void(0)" class="view-more-link" (click)="productCategory('best-selling')">
                            View More 
                            <!-- <span class="arrow">&rarr;</span> -->
                            <span class="arrow">
                                <fa-icon [icon]="faArrowRight"></fa-icon>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!-- 4. IFR Fabric -->
        <section class="product-section bg-grey">
            <div class="container">
                <div class="title-container">
                    <h1 class="hh" (click)="productCategory('sales-clearance')">Inherent Flame Retardant (IFR) Fabric
                    </h1>
                </div>
                <div class="products-grid-wrapper">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 mb-4" *ngFor="let item of ifr | slice:0:3">
                            <a [href]="detailLinkBase + item.productId" class="box">
                                <div class="image-box">
                                    <img [src]="item.image" loading="lazy">
                                </div>
                                <div class="product-info">
                                    <p class="product-name">{{item.productName}}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="view-more-container">
                        <a href="javascript:void(0)" class="view-more-link"
                            (click)="productCategory('sales-clearance')">
                            View More 
                            <!-- <span class="arrow">&rarr;</span> -->
                            <span class="arrow">
                                <fa-icon [icon]="faArrowRight"></fa-icon>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <!-- Category View -->
    <div *ngIf="page_type !== 'home'">
        <section class="product-section bg-white">
            <div class="container">
                <div class="title-container">
                    <h1 class="hh">{{ getCategoryTitle(category_type) }}</h1>
                </div>

                <div class="row">
                    <ng-container [ngSwitch]="category_type">
                        <ng-container *ngSwitchCase="'new-arrivals'">
                            <div class="col-sm-6 col-md-4 mb-4" *ngFor="let item of newArrival">
                                <a [href]="detailLinkBase + item.productId" class="box">
                                    <div class="image-box">
                                        <img [src]="item.image" loading="lazy">
                                    </div>
                                    <div class="product-info">
                                        <p class="product-name">{{item.productName}}</p>
                                    </div>
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'now-trending'">
                            <div class="col-sm-6 col-md-4 mb-4" *ngFor="let item of nowTrending">
                                <a [href]="detailLinkBase + item.productId" class="box">
                                    <div class="image-box">
                                        <img [src]="item.image" loading="lazy">
                                    </div>
                                    <div class="product-info">
                                        <p class="product-name">{{item.productName}}</p>
                                    </div>
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'best-selling'">
                            <div class="col-sm-6 col-md-4 mb-4" *ngFor="let item of bestSelling">
                                <a [href]="detailLinkBase + item.productId" class="box">
                                    <div class="image-box">
                                        <img [src]="item.image" loading="lazy">
                                    </div>
                                    <div class="product-info">
                                        <p class="product-name">{{item.productName}}</p>
                                    </div>
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'sales-clearance'">
                            <div class="col-sm-6 col-md-4 mb-4" *ngFor="let item of ifr">
                                <a [href]="detailLinkBase + item.productId" class="box">
                                    <div class="image-box">
                                        <img [src]="item.image" loading="lazy">
                                    </div>
                                    <div class="product-info">
                                        <p class="product-name">{{item.productName}}</p>
                                    </div>
                                </a>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>

                <!-- Back to Home Link -->
                <div class="view-more-container" style="justify-content: center; margin-top: 50px;">
                    <a href="javascript:void(0)" class="view-more-link" (click)="index()">
                        <!-- &larr; Back to Home -->
                        <span class="arrow left-arrow">
                            <fa-icon [icon]="faArrowLeft"></fa-icon>
                        </span> Back to Home
                    </a>
                </div>
            </div>
        </section>
    </div>
</main>

 